<template>
  <table-view ref="table" class="h-full"
    v-model="selected"
    :value-key="PayloadSingleId"
    :include-key="['idCliente', 'Rol', 'VerTodoEstados']"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :lista-acciones="getAccionesPosibles"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction">
    <template slot="dialogs">
      <Dialog :title="$t('users.delete_user')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteUser }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      
      
      <Dialog :title="$t('groups.link_groups')" :visible.sync="showModalLinkGroups" width="40%" custom-class="min-width-dialog"
        center>
        <div class="overflow-x-hidden" ref="containerSelect" :style="{ 'height': heightContainerSelect }">
          <el-form ref="ruleForm">
            <div class="lg:mb-2">
              <div ref="selectRefAgencies">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('groups.header') }}</label>
                <el-form-item prop="selectedGroups">
                  <base-el-select ref="groupsSelector" class="w-full" :groups="listaGroupsGrouping" v-model="listaGroupsSelected" multiple filterable :disabled="isLoadingSelect" :optionKey="getGroupId"
                    @visible-change="onExpand" @change="onChangeInput"  @select-all="onSelectAll" @unselect-all="onUnselectAll" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" v-if="isAllSelected" @click="$refs.groupsSelector.unselectAll()" mode="secondary-phantom-blue"
              :text="$t('app.unselect_all')" :disabled="!isLoadedData || isLoadingSelect" :loading="isLoadingSelect" />
            <base-button class="w-full" v-if="!isAllSelected" :disabled="!isLoadedData || isLoadingSelect || isEmptyList"
              @click="$refs.groupsSelector.selectAll()" mode="secondary-phantom-blue" :text="$t('app.select_all')"
              :loading="isLoadingSelect" />
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkGroups = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" :loading="isLoadingSelect" :disabled="isLoadingSelect" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { applyLinkHandler(); showModalLinkGroups = false }" :loading="isLoadingSelect"
              :disabled="isLoadingSelect" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('configurations.unlink_statuses')" :visible.sync="showModalUnlinkStatuses" width="40%"
        custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkStatuses }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkStatuses = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { unlinkStatusesHandler(); showModalUnlinkStatuses = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('configurations.link_statuses')" :visible.sync="showModalLinkStatuses" width="40%" custom-class="min-width-dialog"
        center>
        <div class="overflow-x-hidden" ref="containerSelect" :style="{ 'height': heightContainerSelect }">
          <el-form ref="ruleForm">
            <div class="lg:mb-2">
              <div ref="selectRefAgencies">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.status') }}</label>
                <el-form-item prop="tagNombre">
                  <base-el-select ref="statusesSelector" class="w-full" :options="listaStatuses" v-model="listaStatusesSelected" multiple filterable :disabled="isLoadingSelectStatuses"
                    @visible-change="onExpand" @change="onChangeInput" @select-all="loading => loadingActionSelectStatuses = loading" @unselect-all="loading => loadingActionUnSelectStatuses = loading" />
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" v-if="isAllStatusesSelected" @click="$refs.statusesSelector.unselectAll()" ode="primary"
              :text="$t('app.unselect_all')" :disabled="isLoadingSelectStatuses"
              :loading="isLoadingSelectStatuses" />
            <base-button class="w-full" v-if="!isAllStatusesSelected"
              :disabled="isLoadingSelectStatuses || isEmptyStatusesList"
              @click="$refs.statusesSelector.selectAll()" ode="primary" :text="$t('app.select_all')"
              :loading="isLoadingSelectStatuses" />
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkStatuses = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" :loading="isLoadingSelectStatuses" :disabled="isLoadingSelectStatuses" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { applyLinkStatusesHandler(); showModalLinkStatuses = false }"
              :loading="isLoadingSelectStatuses" :disabled="isLoadingSelectStatuses" />
          </div>
        </template>
      </Dialog>

      <import-generic-dialog
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        :header="$t('imports.import_users_header')" 
        />  
      
      
      <Dialog :title="$t('configurations.unlink_statuses')" :visible.sync="showModalUnlinkStatuses" width="40%"
        custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkStatuses
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkStatuses = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { unlinkStatusesHandler(); showModalUnlinkStatuses = false }" />
          </div>
        </template>
      </Dialog>

      <!-- DIALOGO DE RESETEAR CONTRASEÑA Y DE CONFIGURACION DOBLE FACTOR -->

      <!-- DIALOGO: Resetear Contraseña -->
      <Dialog :title="$t('noauth.reset_password')" :visible.sync="showModalResetPassword" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">
          {{ processMessageResetPassword }}
        </span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalResetPassword = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('users.reset')"
              @click="() => { submitResetPassword(this.selected); showModalResetPassword = false }" />
          </div>
        </template>
      </Dialog>

      <!-- DIALOGO: Resetear configuración de doble factor -->
      <Dialog :title="$t('noauth.reset_two_factor_settings')" :visible.sync="showModalResetDobleConfiguracion" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">
          {{ processMessageAuthentication }}
        </span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalResetDobleConfiguracion = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('users.reset')"
              @click="() => { submitResetDobleConfiguracion(this.selected); showModalResetDobleConfiguracion = false }" />
          </div>
        </template>
      </Dialog>
     
    </template>
  </table-view>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/UsersFilter.vue'
import { Dialog } from 'element-ui'
import { getUsers } from '@/services/configurations/getUsers'
import { downloadUsersUexcel } from '@/services/configurations/downloadUsersUexcel'
import { deleteUser } from '@/services/configurations/deleteUser'
import { linkUsersToStatuses } from '@/services/configurations/status/linkUsersToStatuses'
import { unlinkUsersToStatuses } from '@/services/configurations/status/unlinkUsersToStatuses'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { linkUsersGroupsMultiple } from '@/services/configurations/groups/linkUsersGroupsMultiple'

// Imports
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importUsers } from '@/services/configurations/imports/importUsers'
import { downloadTemplateUsers } from '@/services/configurations/imports/downloadTemplateUsers'

import { passwordReset } from '@/services/configurations/passwordReset'
import { resetearConfiguracionDobleFactor } from '@/services/configurations/resetearConfiguracionDobleFactor'
import { changeStateUsers } from '@/services/configurations/changeStateUsers'

export default {
  name: 'users-list-view',
  components: {
    TableView,
    Dialog,
    ImportGenericDialog,
  },
  data () {
    return {
      idVista: 9,
      FilterPanel: CustomFilter,
      vuexnamespace: 'users',
      headerTitle: i18n.t('users.header'),
      headerIcon: 'config',
      routeName: 'configurations/users/details',
      excelName: `${i18n.t('users.header').toLowerCase()}.xlsx`,
      PayloadSingleId: 'idUsuario',
      listaAcciones: [
        { IdAccion: 300, Descripcion: i18n.t('app.enable'), icon: 'check' },
        { IdAccion: 301, Descripcion: i18n.t('app.disable'), icon: 'cross' },
        { IdAccion: 200, Descripcion: i18n.t('configurations.link_statuses'), icon: 'link' },
        { IdAccion: 201, Descripcion: i18n.t('configurations.unlink_statuses'), icon: 'unlink' },
        { IdAccion: 31, Descripcion: i18n.t('noauth.reset_password_email'), icon: 'lock' },
        { IdAccion: 32, Descripcion: i18n.t('noauth.reset_two_factor_settings'), icon: 'retrydoblefactor' },
        { IdAccion: 0, Descripcion: i18n.t('app.remove'), icon: 'trash' },
        { IdAccion: 100, Descripcion: i18n.t('groups.link_groups'), icon: 'groupadd' },
        // { IdAccion: 101, Descripcion: i18n.t('groups.unlink_groups'), icon: 'groupremove' },


      ],
      processMessageDeleteUser: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('users.header').toLowerCase() }),
      processMessageUnlinkStatuses: i18n.t('app.unlink_all_entity_confirmation', { entity: i18n.t('app.statuses').toLowerCase(), from: i18n.t('users.header').toLowerCase() }),
      processMessageResetPassword: i18n.t('app.reset_password_question'),
      processMessageAuthentication: i18n.t('app.reset_two_factor_settings_question'),
      heightSelect: 0,
      heightInput: 35,
      // Import
      showModalImport: false,
      // Links
      listaGroups: [],
      listaGroupsSelected: [],
      listaStatusesSelected: [],
      showModalReset: false,
      showModalLinkGroups: false,
      showModalLinkStatuses: false,
      showModalUnlinkStatuses: false,
      showModalResetPassword: false,
      showModalResetDobleConfiguracion: false,
      showModal: false,
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,
      loadingActionSelectStatuses: false,
      loadingActionUnSelectStatuses: false,
      isNotice: false,
      noticeType: '',
      selected: []
    }
  },
  computed: {
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasImportacionesModule']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    footerAcciones () {
      return [
        {
          hide: !this.hasModuleImportaciones,
          text: i18n.t('app.import'),
          icon: 'import',
          handler: this.toggleImport,
        },
        { 
          text: i18n.t('users.new_user'), 
          icon: 'plus', 
          handler: this.goToNewUser 
        },
      ]
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    listaStatuses: function () {
      return [...this.$store.getters['config/TIPOS_ESTADO'], ...this.$store.getters['config/TIPOS_ESTADO_RECEPCION']]
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.listaGroups.reduce((a, b) => ({ ...a, [groupTypes[b.idTipo]?.name]: [...(a[groupTypes[b.idTipo]?.name] || []), b] }), {})
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.listaGroups === undefined || this.listaGroups === null || this.listaGroups.length === 0
    },
    isEmptyStatusesList: function () {
      return this.listaStatuses === undefined || this.listaStatuses === null || this.listaStatuses.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isLoadingSelectStatuses: function () {
      return this.loadingActionSelectStatuses || this.loadingActionUnSelectStatuses
    },
    isAllSelected: function () {
      if (this.listaGroups.length === this.listaGroupsSelected.length) return true
      else return false
    },
    isAllStatusesSelected: function () {
      if (this.listaStatuses.length === this.listaStatusesSelected.length) return true
      else return false
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        const idCliente = this.selected[0].idCliente
        if (this.selected.some(x => x.idRol === 9)) {
          listaAccionesFinal = []
        }
        // Usuarios de diferentes clientes => Quitamos vincular grupos
        if (this.selected.length !== this.selected.filter(x => x.idCliente === idCliente).length ||
          this.selected.length !== this.selected.filter(x => x.Rol !== 7 && x.Rol !== 8 && x.Rol !== 3).length) {
          listaAccionesFinal.shift()
        }
        if (this.selected.length !== this.selected.filter(x => x.VerTodoEstados === false).length ||
          this.selected.length !== this.selected.filter(x => x.Rol !== 7 && x.Rol !== 8 && x.Rol !== 3).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
        }
        if (this.role !== 3 && this.role !== 7 && this.role !== 8 && this.role !== 2) {
          listaAccionesFinal= this.listaAcciones.filter(x => x.IdAccion !== 31 && x.IdAccion !== 32)
        }
      }
      
      return listaAccionesFinal
    },
    firstUserSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].idUsuario
      return 0
    }
  },
  watch: {
    showModalLinkGroups: async function (val, oldVal) {
      this.isLoadedData = false
      try {
        if (val === true) {
          const data = await getGroupsSimple({ idUsuario: this.firstUserSelected })
          if (data.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
          } else {
            data.Respuesta.forEach(row => {
              this.listaGroups.push(row)
            })
          }
        } else {
          this.listaGroups = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
  },
  created () {
    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      if (this.noticeType === 'usuariospasswordcaducar') {
        this.header.title = i18n.t('avisos.usuariospasswordcaducar')
      } else {
        console.error(i18n.t('feedback.error.noticetype_not_found_error'))
      }
    } else {
      this.isNotice = false
      this.noticeType = ''
    }
  },
  mounted () {
  },
  methods: {
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importUsers(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImport() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateUsers()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-usuarios.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    // METODO DE RESET PASSWORD
    resetPassword: async function () {
      this.showModalResetPassword = !this.showModalResetPassword
    },

    // METODO DE RESET CONFIGURACION DOBLE FACTOR
    resetDobleConfiguracion: async function () {
      this.showModalResetDobleConfiguracion = !this.showModalResetDobleConfiguracion
    },

    // EVENTO CLICK DE RESET PASSWORD
    submitResetPassword: async function (selected) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          IdsUsuarios: []
        }
        for (const element of selected) {
          payload.IdsUsuarios.push(element.idUsuario)
        }
        const response = await passwordReset(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.selected = []
        this.$store.commit('setIsLoading', false)
      }
    },
    // EVENTO CLICK DE RESET CONFIGURACION DOBLE FACTOR
    submitResetDobleConfiguracion: async function (selected) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          IdsUsuarios: []
        }
        for (const element of selected) {
          payload.IdsUsuarios.push(element.idUsuario)
        }
        const response = await resetearConfiguracionDobleFactor(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.selected = []
        this.$store.commit('setIsLoading', false)
      }
    },


    getGroupId: function (option) {
      return option.IdGrupo
    },
    getParamsPathAux (data) {
      return {
        id: data.idUsuario,
        noticeType: this.noticeType 
      }
    },
    getParamsAux (data) {
      return {
        nombre: data.name ? data.name.value : null,
        email: data.email ? data.email.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        rol: data.role ? data.role.value : null,
        tipoAutenticacion: data.tipoAuth ? data.tipoAuth.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        Activo: data.activo ? data.activo.value : null,
        passwordCaducado: this.isNotice,
        LangCode: data.idioma ? data.idioma.value : null
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getUsers(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await downloadUsersUexcel(objOrder, params)
      } catch (error) {}
    },
    goToNewUser: function () {
      this.$router.push({ name: 'configurations/users/details', params: { id: -1 } })
    },
    executeAction: async function ({ action, selected = [], event }) {
      if (selected.length) {
        if (action.IdAccion === 0) { // borrar
          this.deleteUser()
        } else if (action.IdAccion === 31) { // Resetear Contraseña
          this.resetPassword()
        } else if (action.IdAccion === 32) { // Resetear Configuracion Doble Factor
          this.resetDobleConfiguracion()
        } else if (action.IdAccion === 100) { // Link grupos
          this.toggleDialogLinkGroups()
        } else if (action.IdAccion === 201) { // Unink statuses
          this.unlinkStatuses()
        } else if (action.IdAccion === 200) { // Link statuses
          this.toggleDialogLinkStatuses()
        } else if (action.IdAccion === 300) { // Activar
          this.activeHandler(true)
        } else if (action.IdAccion === 301) { // Desactivar
          this.activeHandler(false)
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    selectionChange: function (selected = []) {
      this.selected = selected
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    onSelectAll: function (loading) {
      this.loadingActionSelect = loading
    },
    onUnselectAll: function (loading) {
      this.loadingActionUnSelect = loading
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        if (this.noticeType === 'usuariospasswordcaducar') {
          this.header.title = i18n.t('avisos.usuariospasswordcaducar')
        } else {
          console.error(i18n.t('feedback.error.noticetype_not_found_error'))
        }
      } else {
        this.isNotice = false
        this.noticeType = ''
      }
    },
    applyLinkHandler: async function () {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idUsuarios: [] }
        payload.idGrupos = this.listaGroupsSelected
        payload.idUsuarios = this.selected.map(x => x.idUsuario)
        const response = await linkUsersGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.listaGroupsSelected = []
        this.$refs.table.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkStatusesHandler: async function () {
      this.showModalLinkStatuses = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idEstados: [], idUsuarios: [] }
        payload.idEstados = this.listaStatusesSelected
        payload.idUsuarios = this.selected.map(x => x.idUsuario)
        const response = await linkUsersToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.listaStatusesSelected = []
        this.$refs.table.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogLinkGroups: function () {
      if (this.showModalLinkGroups && this.isLoadingSelect) return
      this.listaGroupsSelected = []
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogLinkStatuses: function () {
      if (this.showModalLinkStatuses && this.isLoadingSelectStatuses) return
      this.listaStatusesSelected = []
      this.showModalLinkStatuses = !this.showModalLinkStatuses
    },
    activeHandler: async function (valueActive) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          IdsUsuarios: this.selected.map(x => x.idUsuario),
          Activo: valueActive,
        }
        const response = await changeStateUsers(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
    deleteUser: async function () {
      this.showModal = !this.showModal
    },
    unlinkStatuses: async function () {
      this.showModalUnlinkStatuses = !this.showModalUnlinkStatuses
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        for (const element of this.selected) {
          payload.idsUsuario.push(element.idUsuario)
        }
        const response = await deleteUser(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.selected = []
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
    unlinkStatusesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.idUsuario)
        }
        const response = await unlinkUsersToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.$refs.table.applyFilters()
    },
  },
}
</script>

<style scoped>

</style>
